import { defineComponent as _defineComponent } from 'vue'
import {
  IFavoriteLine,
  IFavoriteLineData,
} from "@/domain/entities/favoriteLine";
import { computed, PropType, toRefs } from "vue";
import FavoriteLineRow from "./FavoriteLineRow.vue";
import NoFavoriteCard from "./NoFavoriteCard.vue";
import { useRouter } from "vue-router";
import { RouterName } from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "FavoriteLineList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteLines: {
    type: Array as PropType<IFavoriteLine[]>,
    default: () => [],
  },
},
  emits: ["onClickRow", "onClickFavoriteStatusButton", "onClickBoardingStatusButton", "onClickSearch"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const router = useRouter();

const emit = __emit;

// toRefs 로 반응성 유지
const { favoriteLines } = toRefs(props);

// isBoarding = true 인 것만 필터링해서 앞에 붙이고, 나머지는 원래 순서대로
const orderedFavoriteLines = computed<IFavoriteLine[]>(() => {
  const boardingLines = favoriteLines.value.filter((line) => line.isBoarding);
  const otherLines = favoriteLines.value.filter((line) => !line.isBoarding);
  return [...boardingLines, ...otherLines];
});

const goToLineInfoDetail = (line: IFavoriteLineData) => {
  emit("onClickRow", line);
  router.push({
    name: RouterName.LineInfoDetail,
    params: { lineId: line.lineId },
    query: {
      turnId: line.turnId,
      getOnBusStopId: line.getOnBusStop?.id ?? "",
      getOffBusStopId: line.getOffBusStop?.id ?? "",
    },
  });
};

const emitOnClickFavoriteStatusButton = (line: IFavoriteLineData) => {
  emit("onClickFavoriteStatusButton", line);
};
const emitOnClickFavoriteBoardingButton = (line: IFavoriteLineData) => {
  emit("onClickBoardingStatusButton", line);
};

const getFavoriteLineKey = (favoriteLine: IFavoriteLine) => {
  return `${favoriteLine.turnId}_${favoriteLine.getOnBusStop?.id ?? ""}_${
    favoriteLine.getOffBusStop?.id ?? ""
  }`;
};

/** 노선 검색 페이지 이동 */
const goToSearch = () => {
  router.push({ name: RouterName.LineSearch });
};

const __returned__ = { props, router, emit, favoriteLines, orderedFavoriteLines, goToLineInfoDetail, emitOnClickFavoriteStatusButton, emitOnClickFavoriteBoardingButton, getFavoriteLineKey, goToSearch, FavoriteLineRow, NoFavoriteCard, get useGetLineRouteName() { return useGetLineRouteName }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})